module.exports = __webpack_public_path__ + "img/banner.32f6b50b.png";